// extracted by mini-css-extract-plugin
export default {"root":"AlbumsEmpty__root--3qqNT","button":"AlbumsEmpty__button--3BRXH","title":"AlbumsEmpty__title--EHeR_","text":"AlbumsEmpty__text--1UZjC","image":"AlbumsEmpty__image--CyA-s"};